import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function ParkIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="ParkIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M75.316,35.449c-1.03-6.278-6.438-10.98-12.978-10.98c-7.109,0-12.884,5.562-13.146,12.662l4.697,0.174
	c0.168-4.563,3.88-8.137,8.45-8.137c4.573,0,8.284,3.575,8.449,8.14l0.064,1.774l1.725,0.423c3.787,0.929,6.431,4.303,6.431,8.207
	c0,4.662-3.793,8.456-8.455,8.456H54.124v4.699h7.926V72.4H37V61.1l11.9,3.4l1.9-1.8l-12.5-11L37,47.8l11,3.8l2-1.9L38.3,39
	l-1.5-4.2l6.5,2.1l-8.7-14.3l-8.7,14.3l6.5-2.1L30.9,39L19.2,49.7l1.9,1.9l11.1-3.8l-1.3,3.9l-12.5,11l1.9,1.8l11.9-3.4v11.3h-9.5
	v4.5h9.5h44.138v-4.5H66.75V60.867h3.801c7.254,0,13.155-5.901,13.155-13.155C83.707,42.21,80.33,37.384,75.316,35.449z"/>
    </svg>
  </SvgIcon>
}

export default ParkIcon;
